
import { createTheme } from '@mui/material/styles';

export function createAppTheme(mode = 'light') {
  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      primary: {
        main: '#2563eb', // Modern Blue
        light: '#60a5fa',
        dark: '#1e40af',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#7c3aed', // Violet
        light: '#a78bfa',
        dark: '#5b21b6',
        contrastText: '#ffffff',
      },
      background: {
        default: isDark ? '#0b1220' : '#f3f4f6',
        paper: isDark ? '#0f172a' : '#ffffff',
      },
      text: {
        primary: isDark ? '#e5e7eb' : '#1f2937',
        secondary: isDark ? '#9ca3af' : '#6b7280',
      },
      divider: isDark ? 'rgba(255,255,255,0.10)' : 'rgba(0,0,0,0.08)',
    },
    typography: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      h1: { fontWeight: 500 },
      h2: { fontWeight: 500 },
      h3: { fontWeight: 500 },
      h4: { fontWeight: 500 },
      h5: { fontWeight: 500 },
      h6: { fontWeight: 500 },
      button: { textTransform: 'none', fontWeight: 500 },
    },
    shape: {
      borderRadius: 14,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 14,
            padding: '10px 18px',
            boxShadow: 'none',
            '&:hover': {
              boxShadow:
                '0 8px 18px rgba(0,0,0,0.10)',
            },
          },
          containedPrimary: {
            background: 'linear-gradient(to right, #2563eb, #7c3aed)',
            '&:hover': {
              background: 'linear-gradient(to right, #1d4ed8, #6d28d9)',
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              borderRadius: 14,
            },
          },
        },
      },
    },
  });
}

export default createAppTheme('light');
